import { render, staticRenderFns } from "./UpdateBusinessForm.vue?vue&type=template&id=3c7a9142&"
import script from "./UpdateBusinessForm.vue?vue&type=script&lang=js&"
export * from "./UpdateBusinessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports